// LICENSE_CODE ZON
'use strict'; /*jslint node:true, es6:true, react:true*/
import React, {useContext, useMemo, useState, Fragment} from 'react';
import styles from './download/download.module.less';
import {Settings_context} from '../../settings_ctx';
import {App_context} from 'hola_app_context';
import cn from 'classnames';
import hola_versions from 'svc_versions';
// @ts-ignore
import {hola_apps, get_link, get_exe_link} from '../../install_util';
// @ts-ignore
import {ga_track_download_send} from '../../ga';
import {Tab_buttons} from '../../ui/premium/tab_buttons';
import {use_qs} from '../../lib/use_qs';
import {Button} from '../../lib/button';
import {use_screen} from '../../lib/screen_util';
import {use_download} from '../../ui/use_download';
import {Svg_img} from '../../ui/svg_img';

const get_version = name=>{
  switch (name)
  {
  case 'browser_mac':
      return hola_versions.chromium_br_mac_build_0_percent;
  case 'browser':
  case 'windows':
  case 'windows32':
  case 'windows64':
      return hola_versions.windows_0_percent;
  case 'windows32beta':
  case 'windows64beta':
      return hola_versions.windows_beta;
  case 'firefox':
      return hola_versions.firefox_full;
  case 'android_beta_arm':
  case 'android_beta_x86':
      return hola_versions.android_5_percent + ' Beta';
  case 'android_arm':
  case 'android_x86':
  case 'androidtv':
      return hola_versions.android;
  case 'mac_beta':
      return hola_versions.iosmac2e;
  default:
      return hola_versions[name];
  }
};

export const Root = props=>{
    return <Download_root_hola2023 {...props}/>;
};

const features = [
    {
        title: <>Ultra-fast and stable <br/> connection</>,
        description: 'Our high-speed stable network will get you '
            +'the best connectivity out there!',
        image: 'http://hola.org/cms/wp-content/uploads/2024/09/'
            +'fastwatch_img.png',
    },
    {
        title: <>Use across all your <br /> devices </>,
        description: 'Use Hola on your tablet, TV, laptop, or phone with '
            +'our selection of apps!',
        image: 'http://hola.org/cms/wp-content/uploads/2024/09/'
            +'devices_img.png',
    },
    {
        title: <>24/7 Customer Support <br/> Center</>,
        description: 'Get in touch anytime. We\'re there whenever '
            +'you need us!',
        image: 'http://hola.org/cms/wp-content/uploads/2024/09/'
            +'support_img.png',
    },
];

interface i_feature_props {
  image: string;
  title: JSX.Element;
  description: string;
}

const Feature = ({image, title, description}: i_feature_props)=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.feature}>
      <div className={styles.feature_image}>
        <img src={image} alt="image" className="lazyload"/>
      </div>
      <p className={cn(theme.p1, styles.feature_title)}>{title}</p>
      <p className={cn(theme.p2, theme.reg, styles.feature_description)}>
        {description}</p>
    </div>;
};

const Features = ()=>{
  const {theme} = useContext(Settings_context);
  return <div className={styles.features_container}>
    <h4 className={cn(theme.h4, styles.features_title)}>You'll love Hola!</h4>
    <div className={styles.features}>
      {features.map((f, i)=><Feature {...f} key={i}/>)}
    </div>
  </div>;
};

interface i_product {
    name: string,
    type?: string;
    title: string;
    compatibility?: string;
    href?: string;
    icon_id: string;
}

const products: {[p: string]: i_product} = {
    chrome: {
        name: 'chrome',
        type: 'browsers',
        title: 'Chrome extension',
        compatibility: 'Windows / Mac / Linux',
        icon_id: 'svg/pl/ic-chrome2.svg',
    },
    edge: {
        name: 'edge',
        type: 'browsers',
        title: 'Microsoft Edge add-on',
        compatibility: 'Windows / Mac / Linux',
        icon_id: 'svg/pl/ic-edge2.svg',
    },
    opera: {
        name: 'opera',
        type: 'browsers',
        title: 'Opera extension',
        compatibility: 'Windows / Mac / Linux',
        icon_id: 'svg/pl/ic-opera2.svg',
    },
    android: {
        name: 'android',
        type: 'mobile',
        title: 'Android',
        compatibility: 'Android 5.0 and above',
        icon_id: 'svg/pl/ic-android-active.svg',
    },
    ios: {
        name: 'ios',
        type: 'mobile',
        title: 'iOS',
        compatibility: 'iOS 12.0 and above',
        icon_id: 'svg/pl/ic-apple2.svg',
    },
    huawei: {
        name: 'huawei',
        type: 'mobile',
        title: 'Huawei',
        compatibility: 'Android 5.0 and above',
        icon_id: 'svg/pl/ic-huawei2.svg',
    },
    samsung: {
        name: 'samsung',
        type: 'mobile',
        title: 'Samsung',
        compatibility: 'Android 5.0 and above',
        icon_id: 'svg/pl/ic-samsung2.svg',
    },
    hola_browser_win: {
        name: 'browser',
        title: 'Hola Browser',
        compatibility: 'Windows 7, 8, 10, 11',
        href: get_exe_link({hola_browser: true, os: 'windows'}),
        icon_id: 'svg/pl/ic-hola-browser2.svg',
    },
    hola_browser_mac: {
        name: 'browser_mac',
        title: 'Hola Browser',
        compatibility: 'macOS 10.13 and above',
        href: get_exe_link({hola_browser: true, os: 'macos',
            version: hola_versions.mac_installer}),
        icon_id: 'svg/pl/ic-hola-browser2.svg',
    },
    windows: {
        name: 'windows',
        type: 'desktop',
        title: 'Windows',
        compatibility: 'Windows 7, 8, 10, 11',
        icon_id: 'svg/pl/ic-windows2.svg',
    },
    macos: {
        name: 'mac_beta',
        type: 'desktop',
        title: 'macOS',
        compatibility: 'macOS 10.15 and above',
        icon_id: 'svg/pl/ic-macos2.svg',
    },
    firetv: {
        name: 'firetv',
        type: 'tv',
        title: 'Fire TV',
        icon_id: 'svg/pl/ic-firetv2.svg',
    },
    lg: {
        name: 'lg',
        type: 'tv',
        title: 'LG',
        icon_id: 'svg/pl/ic-lg2.svg',
    },
    appletv: {
        name: 'appletv',
        type: 'tv',
        title: 'Apple TV',
        icon_id: 'svg/pl/ic-appletv2.svg',
    },
    smarttv: {
        name: 'smarttv',
        type: 'tv',
        title: 'Smart TV',
        icon_id: 'svg/pl/ic-smarttv2.svg',
    },
    xbox: {
        name: 'xbox',
        type: 'other',
        title: 'Xbox',
        icon_id: 'svg/pl/ic-xbox2.svg',
    },
    playstation: {
        name: 'playstation',
        type: 'other',
        title: 'PlayStation',
        icon_id: 'svg/pl/ic-playstation2.svg',
    },
    routers: {
        name: 'router',
        type: 'other',
        title: 'Routers',
        icon_id: 'svg/pl/ic-routers2.svg',
    },
};
const SETUP_GUIDE_PRODUCTS = [
  'routers',
  'playstation',
  'xbox',
  'smarttv'
];

const BROWSERS = [
  'hola_browser_win',
  'hola_browser_mac',
];

const PLATFORMS = [
  'windows', 'mac', 'mac_beta'
];

const Product = ({id}: {id: string})=>{
    const {name, type, title, compatibility, href, icon_id} = products[id];
    const {theme} = useContext(Settings_context);
    const {has_svc, svc_info} = useContext(App_context);
    const has_setup = SETUP_GUIDE_PRODUCTS.includes(id) ;
    const download_link = get_link({has_svc, svc_info, item: {name,
        href: href || hola_apps[type]?.find(p=>p.name==name)?.href}});
    const {download_br} = use_download();
    const on_download = ()=>{
      download_br({cb: ()=>{
        // waiting for iframe to start actial downloading
        setTimeout(()=>{
            // absolute link for holabrowser.com
            window.location.href =
                'https://hola.org/after_download?s=install&browser=1';
        }, 1000);
      }});
  };
    return <div className={styles.product}>
      <div className={styles.product_title}>
        <Svg_img id={icon_id} w={20} h={20} cls={styles.product_icon}/>
        <p className={cn(theme.p3, theme.med)}>{title}</p>
      </div>
      <p className={cn(theme.p3, theme.reg, styles.product_compatibility)}>
        {compatibility}</p>
      <p className={cn(theme.p3, theme.reg, styles.product_version)}>
        {get_version(name)}</p>
      <div className={styles.button_wrapper}>
        <Button caption={has_setup ? 'Setup guide' : 'Download'}
          w100={true}
          to={BROWSERS.includes(id) ? null : download_link}
          cls={styles.download_button} size="xs" color="white"
          icon_right={!has_setup && <Svg_img
            id={'hola2023/icons/16/download.svg'} w={12} h={12}/>}
          on_click={()=>{
            if (BROWSERS.includes(id))
              return on_download();
            if (PLATFORMS.includes(name))
            {
              ga_track_download_send(name=='windows' ? 'exe' : 'dmg',
                'downloads', download_link, null, undefined, {});
            }
          }}/>
      </div>
    </div>;
};

const Browsers = ()=>{
    return <Fragment>
      <Product id="chrome"/>
      <Product id="edge"/>
      <Product id="opera"/>
    </Fragment>;
};

const Mobile = ()=>{
    return <Fragment>
      <Product id="android"/>
      <Product id="ios"/>
      <Product id="huawei"/>
      <Product id="samsung"/>
    </Fragment>;
};

const Desktop = ()=>{
    const {theme} = useContext(Settings_context);
    return <Fragment>
      <p className={cn(theme.p3, theme.med, styles.hola_browser_section)}>
        Hola Browser</p>
      <Product id="hola_browser_win"/>
      <Product id="hola_browser_mac"/>
      <p className={cn(theme.p3, theme.med, styles.desktop_apps_section)}>
        Desktop Apps</p>
      <Product id="windows"/>
      <Product id="macos"/>
    </Fragment>;
};

const TV = ()=>{
    return <Fragment>
      <Product id="firetv"/>
      <Product id="lg"/>
      <Product id="appletv"/>
      <Product id="smarttv"/>
    </Fragment>;
};

const Other = ()=>{
    return <Fragment>
      <Product id="xbox"/>
      <Product id="playstation"/>
      <Product id="routers"/>
    </Fragment>;
};

interface i_download_root_hola2023 {
  title?: string | JSX.Element;
  subtitle?: string | JSX.Element;
}

const Hero = props=>{
  const {theme} = useContext(Settings_context);
  const {width} = use_screen();
  const is_tablet = width < 1440;
  const title = props.title || 'Latest versions of Hola for every device';
  const subtitle = props.subtitle ||
    'We\'ve got you covered with Hola apps for all your devices!';
  return <Fragment>
          {is_tablet ? <h4 className={styles.page_title}>{title}
        </h4> : <h3
        className={styles.page_title}>{title}</h3>}
      <p className={cn(theme.med, styles.page_subtitle)}>
        {subtitle}
        </p>
  </Fragment>;
};

export const Download_root_hola2023 = (props: i_download_root_hola2023)=>{
  const {theme} = useContext(Settings_context);
    const tabs = useMemo(()=>[
        {id: 'browsers', title: 'Browsers', component: <Browsers/>},
        {id: 'mobile', title: 'Mobile', component: <Mobile/>},
        {id: 'desktop', title: 'Desktop', component: <Desktop/>},
        {id: 'tv', title: 'TV', component: <TV/>},
        {id: 'other', title: 'Other', component: <Other/>},
    ], []);
    const qs = use_qs();
    const [active_tab, set_active_tab] = useState<string>(qs.tab || 'desktop');
    return <div className={cn(theme.root, styles.page)}>
      <Hero {...props}/>
      <Tab_buttons items={tabs} active={active_tab} on_change={set_active_tab}
        sliding class_name={styles.tab_buttons}/>
      <div className={styles.products}>
        {tabs.find(t=>t.id==active_tab).component}
      </div>
      <Features/>
    </div>;
};

Root.meta = {
    no_ssr: true,
    ssr_force: false,
    default_theme: 'hola2023',
    meta: {
        title: 'Hola | Download the Right Hola App on All Your Devices!',
        description: 'From browser apps to desktop apps to TV apps, we’ve got '
            +'you covered with Hola apps for all your devices! Access your '
            +'favorite websites by downloading Hola now.',
        canonical_url: 'https://hola.org/download',
    },
};
